import Calendar from "../Calendar";

export default class MoveCalendarByDirectionUseCase {
  public static move(direction: number, calendar: Calendar): void {
    if (direction > 0) calendar.moveNext();
    else calendar.movePrev();
  }
}
